<template>
  <el-dialog
    title="Редактирование пользователя"
    :visible="visible"
    custom-class="el-dialog--small"
    :close-on-click-modal="false"
    @update:visible="closeDialog"
    @open="handleDialogOpen">
    <el-form
      ref="form"
      :model="model"
      :rules="rules"
      @submit.native.prevent="onSubmit">
      <el-form-item label="Логин" prop="login">
        <el-input v-model="model.login" type="text" disabled />
      </el-form-item>
      <el-form-item label="Ф.И.О" prop="name">
        <el-input v-model="model.name" type="text" />
      </el-form-item>
      <el-form-item label="E-mail" prop="email">
        <el-input v-model="model.email" autocomplete="new-password" type="email" />
      </el-form-item>
      <el-form-item label="Пароль (заполнять для изменения)" prop="password">
        <el-input
          v-model="model.password"
          autocomplete="new-password"
          type="text"
          show-password />
      </el-form-item>
      <el-form-item label="Доступ к базам" prop="databases">
        <el-select
          v-model="model.databasesIds"
          value-key="id"
          multiple
          clearable
          class="w-100">
          <el-option
            v-for="database in databases"
            :key="database.id"
            :label="database.name"
            :value="database.id" />
        </el-select>
      </el-form-item>
      <el-form-item prop="isAdmin">
        <div class="flex-x-between flex-y-center">
          <el-checkbox
            v-model="model.isAdmin"
            :disabled="userId === onlyAdminId">
            Администратор
          </el-checkbox>
          <el-button
            v-if="userId !== onlyAdminId"
            size="small"
            type="danger"
            plain
            :loading="$mip('deleteUser')"
            @click="deleteUser">
            Удалить
          </el-button>
        </div>
      </el-form-item>
      <el-form-item prop="hasAccountAccess">
        <el-checkbox
          v-model="model.hasAccountAccess"
          :disabled="model.isAdmin">
          Доступ в ЛК
        </el-checkbox>
      </el-form-item>
      <div class="divider" />
      <div class="flex-x-center">
        <el-button
          type="primary"
          size="medium"
          native-type="submit"
          :loading="$mip('editUser')">
          Сохранить
        </el-button>
        <el-button
          type="primary"
          size="medium"
          plain
          @click="closeDialog">
          Отменить
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { clearFormData } from '@/utils'
  import { mapGetters, mapActions, mapState } from 'vuex'

  export default {
    props: {
      visible: Boolean,
      userId: String,
      onlyAdminId: String
    },

    data() {
      return {
        rules: {
          name: [
            { required: true, message: 'Пожалуйста, введите Ф.И.О', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'Пожалуйста, введите email', trigger: 'blur' },
            { type: 'email', message: 'Пожалуйста, введите правильный email', trigger: ['blur', 'change'] }
          ],
          password: [
            { min: 5, message: 'Пароль должен содержать минимум 5 символов' }
          ]
        },
        model: {
          login: '',
          name: '',
          email: '',
          password: '',
          databasesIds: [],
          isAdmin: false,
          hasAccountAccess: false
        }
      }
    },

    computed: {
      ...mapState({
        databases: state => state.databases.databases,
        accData: state => state.user.accInfo
      }),

      ...mapGetters([ 'getUserById', 'getDatabaseById' ])
    },

    methods: {
      ...mapActions({
        editAction: 'editUser',
        deleteAction: 'deleteUser'
      }),

      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.editUser()
          } else {
            console.error('Error: form validation')
            return false
          }
        })
      },

      async editUser() {
        await this.editAction(this.model)
        this.closeDialog()
        this.$notify({
          title: 'Редактирование пользователя',
          message: 'Данные пользователя успешно изменены',
          type: 'success'
        })
      },

      deleteUser() {
        this.$confirm('Вы уверены, что хотите навсегда удалить пользователя?', 'Удаление пользователя', {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          confirmButtonClass: 'bg-danger',
          type: 'warning'
        }).then(() => {
          this.deleteAction(this.userId)
          this.closeDialog()
          this.$notify({
            title: 'Удаление пользователя',
            message: 'Пользователь успешно удален',
            type: 'success'
          })
        })
      },

      handleDialogOpen() {
        this.model = this.getUserById(this.userId)
      },

      closeDialog() {
        this.$emit('update:visible', false)
        this.model = clearFormData(this.model, { isAdmin: false })
      }
    }
  }
</script>